import { render, staticRenderFns } from "./weidianOrderDetail.vue?vue&type=template&id=60fa15b4&scoped=true"
import script from "./weidianOrderDetail.vue?vue&type=script&lang=ts"
export * from "./weidianOrderDetail.vue?vue&type=script&lang=ts"
import style0 from "./weidianOrderDetail.vue?vue&type=style&index=0&id=60fa15b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fa15b4",
  null
  
)

export default component.exports